<template>
    <div class="upload-wrap" ref="appContainer" style="height: calc(100vh - 90px);">
        <iframe
                :src="url"
                style="width: 100%;height: 100%">
        </iframe>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                url: 'https://zscx.osta.org.cn/',
            }
        },
        created() {

        },
        methods: {

        }
    }
</script>

<style scoped>
    .upload-wrap{
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/certificate/index.vue